<template>
   <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/5.15.4/css/all.min.css"/>
  <div class="login-main">
    <div class="bg-grid"></div>
    <div class="bg-glow"></div>
    <div class="login-right">
      <div class="card-login">
        <h1>Logar</h1>
        <form autocomplete="off" @submit.prevent="login">
          <div class="textfield email-field">
            <i class="fas fa-envelope leading-icon"></i> <!-- Font Awesome Email Icon -->
            <input
              type="email"
              id="email"
              name="login_email"
              v-model="email"
              :placeholder="placeholderEmail"
              @input="onEmailInput"
              @focus="handleEmailFocus"
              @blur="handleEmailBlur"
              autocomplete="off"
              autocorrect="off"
              autocapitalize="none"
              spellcheck="false"
              inputmode="email"
            />
            <div v-if="shouldShowEmailSuggestions" class="email-suggestions">
              <button
                v-for="suggestion in emailSuggestions"
                :key="suggestion"
                type="button"
                class="email-suggestion-item"
                @mousedown.prevent="applyEmailSuggestion(suggestion)"
              >
                {{ suggestion }}
              </button>
            </div>
          </div>
          <div class="textfield">
            <i class="fas fa-lock leading-icon"></i> <!-- Font Awesome Lock Icon -->
            <input
              :type="showPassword ? 'text' : 'password'"
              id="password"
              v-model="password"
              :placeholder="placeholderPassword"
              @focus="clearPlaceholder('password')"
              @blur="resetPlaceholder('password')"
              autocomplete="off"
            />
            <button
              type="button"
              class="toggle-eye"
              @click="togglePasswordVisibility"
              :aria-label="showPassword ? 'Ocultar senha' : 'Mostrar senha'"
            >
              <i :class="showPassword ? 'fas fa-eye' : 'fas fa-eye-slash'"></i>
            </button>
          </div>
          <div class="auth-row">
            <label class="remember-option">
              <input v-model="rememberMe" type="checkbox" />
              <span>Lembrar de mim</span>
            </label>
            <router-link :to="{ name: 'mudaSenha' }" class="forgot-password">Esqueci minha senha</router-link>
          </div>
          <button type="submit" class="button-login">Login</button>
        </form>
      </div>
      <p class="no-access-cta">
        NÃO TEM ACESSO?
        <router-link :to="{ name: 'LandingPage' }" class="acquire-link">Adquira já</router-link>
      </p>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import { API_BASE_URL } from '@/config/env';
import { toastError, toastSuccess } from '@/utils/toast';
export default {
  name: "Login",
  data() {
    return {
      email: "",
      password: "",
      placeholderEmail: "Email",
      placeholderPassword: "Senha",
      showPassword: false,
      rememberMe: false,
      showEmailSuggestions: false,
      emailDomainOptions: ['gmail.com', 'outlook.com', 'hotmail.com', 'yahoo.com'],
    };
  },
  computed: {
    emailSuggestions() {
      if (!this.showEmailSuggestions) return [];
      const emailValue = String(this.email || '').trim();
      const atIndex = emailValue.indexOf('@');
      if (atIndex < 1) return [];
      if (emailValue.indexOf('@', atIndex + 1) !== -1) return [];

      const localPart = emailValue.slice(0, atIndex);
      const typedDomain = emailValue.slice(atIndex + 1).toLowerCase();
      if (!localPart) return [];

      return this.emailDomainOptions
        .filter((domain) => domain.startsWith(typedDomain))
        .map((domain) => `${localPart}@${domain}`)
        .filter((suggestion) => suggestion.toLowerCase() !== emailValue.toLowerCase());
    },
    shouldShowEmailSuggestions() {
      return this.showEmailSuggestions && this.emailSuggestions.length > 0;
    }
  },
  methods: {
    async login() {
      try {
        const response = await axios.post(`${API_BASE_URL}/api/v1/auth/login`, {
          email: this.email,  // ← CORRIGIDO
          password: this.password
        }, {
          headers: {
            'Content-Type': 'application/json'
          }
        });

        if (response.data.token) {
          if (response.data.first_login === true) {
            sessionStorage.setItem('zima_show_welcome_once', '1');
          } else {
            sessionStorage.removeItem('zima_show_welcome_once');
          }
          if (this.rememberMe) {
            localStorage.setItem('token', response.data.token);
            sessionStorage.removeItem('token');
          } else {
            sessionStorage.setItem('token', response.data.token);
            localStorage.removeItem('token');
          }
          if (response.data.user) {
            this.$store.dispatch('setUser', response.data.user);
          }
          toastSuccess('Login realizado com sucesso!');
          this.$router.push('/');
        } else {
          toastError('Erro no login');
        }
      } catch (error) {
        console.error('Erro ao fazer login:', error);
        
        // Mostrar mensagem de erro específica
        if (error.response && error.response.data && error.response.data.error) {
          toastError(error.response.data.error);
        } else {
          toastError('Erro ao fazer login. Verifique suas credenciais.');
        }
      }
    },
    
    clearPlaceholder(field) {
      if (field === 'email') {
        this.placeholderEmail = "";
      } else if (field === 'password') {
        this.placeholderPassword = "";
      }
    },
    
    resetPlaceholder(field) {
      if (field === 'email' && !this.email) {
        this.placeholderEmail = "Email";
      } else if (field === 'password' && !this.password) {
        this.placeholderPassword = "Senha";
      }
    },
    onEmailInput() {
      this.showEmailSuggestions = true;
    },
    handleEmailFocus() {
      this.clearPlaceholder('email');
      this.showEmailSuggestions = true;
    },
    handleEmailBlur() {
      this.resetPlaceholder('email');
      window.setTimeout(() => {
        this.showEmailSuggestions = false;
      }, 120);
    },
    applyEmailSuggestion(suggestion) {
      this.email = suggestion;
      this.showEmailSuggestions = false;
    },

    togglePasswordVisibility() {
      this.showPassword = !this.showPassword;
    }
  }
};
</script>
<style scoped>
/* Global Styles */
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  font-family: 'Noto Sans', sans-serif;
}

body * {
  box-sizing: border-box;
}

/* Main login page container */
.login-main {
  width: 100%;
  min-height: 100dvh;
  --bg: #11131a;
  --accent-a: rgba(78, 115, 223, 0.12);
  --accent-b: rgba(155, 89, 182, 0.14);
  position: relative;
  overflow: hidden;
  background:
    radial-gradient(circle at top left, var(--accent-a), transparent 45%),
    radial-gradient(circle at top right, var(--accent-b), transparent 40%),
    var(--bg);
  display: flex;
  justify-content: center;
  align-items: center;
}

.bg-grid,
.bg-glow {
  position: fixed;
  inset: 0;
  pointer-events: none;
  z-index: 0;
}

.bg-grid {
  background:
    linear-gradient(rgba(255, 255, 255, 0.04) 1px, transparent 1px),
    linear-gradient(90deg, rgba(255, 255, 255, 0.04) 1px, transparent 1px);
  background-size: 32px 32px;
  opacity: 0.4;
}

.bg-glow {
  background: transparent;
}

/* Right side for login card, centered */
.login-right {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  position: relative;
  z-index: 1;
  gap: 14px;
}

/* Centralized login card with glass effect */
.card-login {
  width: min(400px, 100%);
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  padding: 30px 35px;
  border-radius: 15px;
  border: 1px solid transparent;
  background:
    linear-gradient(160deg, rgba(18, 26, 44, 0.72), rgba(13, 19, 34, 0.78)) padding-box,
    linear-gradient(120deg, #4e73df, #9b59b6) border-box;
  backdrop-filter: blur(18px) saturate(120%);
  -webkit-backdrop-filter: blur(18px) saturate(120%);
  box-shadow:
    inset 0 1px 0 rgba(255, 255, 255, 0.08),
    0 0 0 1px rgba(78, 115, 223, 0.24),
    0 14px 30px rgba(4, 10, 24, 0.5),
    0 0 26px rgba(155, 89, 182, 0.2);
}

/* Title of the card */
.card-login h1 {
  color: #ffffff;
  font-weight: 600;
  margin: 0;
  margin-bottom: 20px;
}

/* Styling for text fields with icons */
.textfield {
  display: flex;
  align-items: center;
  position: relative;
  width: 100%;
  margin-bottom: 20px;
}

.email-field {
  margin-bottom: 20px;
}

/* Styling for input fields */
.textfield input {
  flex: 1;
  border: none;
  border-radius: 10px;
  padding: 15px 50px 15px 50px; /* Space for both icons */
  background: rgba(255, 255, 255, 0.2); /* Consistent background */
  color: #ffffff;
  font-size: 12pt;
  outline: none;
  transition: background-color 0.3s ease;
}

/* Placeholder text color (lighter white) */
.textfield input::placeholder {
  color: rgba(255, 255, 255, 0.6);
}

/* Leading icons on inputs */
.leading-icon {
  position: absolute;
  left: 15px;
  color: rgba(255, 255, 255, 0.7);
  font-size: 16px;
  transition: visibility 0.3s ease, opacity 0.3s ease;
}

.toggle-eye {
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
  background: transparent;
  border: none;
  color: rgba(255, 255, 255, 0.75);
  font-size: 16px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 4px;
}

.toggle-eye:hover {
  color: #ffffff;
}

/* Hiding the icon when input is focused */
.textfield input:focus ~ .leading-icon {
  visibility: hidden;
  opacity: 0;
}

.toggle-eye i {
  position: static;
}

/* Autofill field colors - Ensuring the background doesn't change to white */
input:-webkit-autofill,
input:-webkit-autofill:hover,
input:-webkit-autofill:focus,
input:-webkit-autofill:active {
  -webkit-box-shadow: 0 0 0px 1000px rgba(255, 255, 255, 0.2) inset !important; /* Ensures background stays consistent */
  background-color: rgba(255, 255, 255, 0.2) !important; /* Matches the input field background */
  -webkit-text-fill-color: #ffffff !important; /* Ensures autofilled text remains white */
  transition: background-color 5000s ease-in-out 0s;
}

/* Remove the border on focus */
.textfield input:focus {
  outline: none;
  box-shadow: none;
  border: none;
}

.email-suggestions {
  position: absolute;
  top: calc(100% + 8px);
  left: 0;
  right: 0;
  z-index: 30;
  border-radius: 10px;
  overflow: hidden;
  border: 1px solid rgba(115, 148, 240, 0.45);
  background: rgba(11, 16, 30, 0.96);
  backdrop-filter: blur(12px);
  box-shadow: 0 10px 24px rgba(2, 8, 20, 0.55);
}

.email-suggestion-item {
  width: 100%;
  padding: 10px 12px;
  border: 0;
  background: transparent;
  color: rgba(237, 244, 255, 0.92);
  text-align: left;
  font-size: 0.9rem;
  cursor: pointer;
  transition: background-color 0.18s ease, color 0.18s ease;
}

.email-suggestion-item + .email-suggestion-item {
  border-top: 1px solid rgba(255, 255, 255, 0.07);
}

.email-suggestion-item:hover {
  background: rgba(78, 115, 223, 0.2);
  color: #ffffff;
}

.auth-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 20px;
}

.remember-option {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  color: #ffffff;
  font-size: 0.9rem;
  font-weight: 400;
  line-height: 1;
  cursor: pointer;
  user-select: none;
}

.remember-option input[type='checkbox'] {
  appearance: none;
  -webkit-appearance: none;
  width: 16px;
  height: 16px;
  margin: 0;
  flex-shrink: 0;
  vertical-align: middle;
  border-radius: 4px;
  border: 1px solid rgba(255, 255, 255, 0.55);
  background: rgba(255, 255, 255, 0.08);
  display: inline-grid;
  place-content: center;
  transition: border-color 0.2s ease, background-color 0.2s ease;
}

.remember-option input[type='checkbox']::before {
  content: '';
  width: 8px;
  height: 8px;
  border-radius: 2px;
  transform: scale(0);
  transition: transform 0.18s ease;
  background: linear-gradient(135deg, #4e73df 0%, #9b59b6 100%);
}

.remember-option input[type='checkbox']:checked {
  border: 1px solid transparent;
  background:
    linear-gradient(rgba(255, 255, 255, 0.14), rgba(255, 255, 255, 0.14)) padding-box,
    linear-gradient(135deg, #4e73df 0%, #9b59b6 100%) border-box;
}

.remember-option input[type='checkbox']:checked::before {
  transform: scale(1);
}

/* Forgot password link styling */
.forgot-password {
  display: inline-flex;
  align-items: center;
  color: #ffffff;
  text-decoration: none;
  font-size: 0.9rem;
  font-weight: 400;
  line-height: 1;
}

.forgot-password:hover {
  text-decoration: underline;
}

/* Login button */
.button-login {
  width: 100%;
  padding: 12px 0px;
  border-radius: 50px;
  text-transform: uppercase;
  font-weight: 700;
  color: #ffffff;
  background: linear-gradient(135deg, #4e73df 0%, #9b59b6 100%);
  cursor: pointer;
  border: none;
  transition: background 0.3s ease, transform 0.3s ease;
}

.button-login:hover {
  background: linear-gradient(135deg, #5f27cd 0%, #3498db 100%);
  transform: translateY(-3px);
}

.no-access-cta {
  margin: 0;
  color: #ffffff;
  font-size: 0.9rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  line-height: 1.2;
}

.acquire-link {
  margin-left: 6px;
  display: inline-block;
  position: relative;
  background-image: linear-gradient(90deg, #4e73df 0%, #9b59b6 50%, #4e73df 100%);
  background-size: 200% 100%;
  background-position: 0% 50%;
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
  text-decoration: none;
  font-weight: 700;
  text-transform: uppercase;
  transition: background-position 0.25s ease-in-out, transform 0.25s ease-in-out, filter 0.25s ease-in-out;
  filter: drop-shadow(0 0 8px rgba(120, 120, 255, 0.22));
  animation: acquire-soft-glow 2.6s ease-in-out infinite;
}

.acquire-link::after {
  content: '';
  position: absolute;
  left: 0;
  bottom: -2px;
  width: 100%;
  height: 1px;
  background: linear-gradient(90deg, rgba(78, 115, 223, 0.2), rgba(155, 89, 182, 0.85), rgba(78, 115, 223, 0.2));
  opacity: 0.75;
  transform: scaleX(0.9);
  transform-origin: center;
  transition: opacity 0.25s ease-in-out, transform 0.25s ease-in-out;
}

.acquire-link:hover {
  background-position: 100% 50%;
  transform: translateY(-1px);
  filter: drop-shadow(0 0 12px rgba(143, 112, 255, 0.35));
}

.acquire-link:hover::after {
  opacity: 1;
  transform: scaleX(1);
}

.acquire-link:focus-visible {
  outline: none;
  filter: drop-shadow(0 0 12px rgba(143, 112, 255, 0.38));
}

@keyframes acquire-soft-glow {
  0%, 100% {
    filter: drop-shadow(0 0 8px rgba(120, 120, 255, 0.22));
  }
  50% {
    filter: drop-shadow(0 0 11px rgba(155, 89, 182, 0.3));
  }
}

/* Responsive adjustments */
@media only screen and (max-width: 1199px) {
  .card-login {
    width: 85%;
  }
}

@media only screen and (max-width: 767px) {
  .login-main {
    flex-direction: column;
  }

  .login-right {
    width: 100%;
    height: auto;
  }

  .card-login {
    width: 90%;
  }
}


</style>
